<template>
  <div
    class="modal fade"
    id="uploadImageModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="uploadImageModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="uploadImageModalLabel">Upload Gambar</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeModal"
            @click="closeModal"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row g-1">
            <div class="col-lg-4">
              <div class="card">
                <div class="card-body">
                  <h6 class="mb-1">Saat ini</h6>
                  <div class="file-container">
                    <img
                      :src="detailAdd.imageurl || require('../../assets/image/noimage.png')"
                      alt="Image Preview"
                      class="img img-fluid"
                      loading="lazy"
                      style="width: 200px"
                      @error="event => event.target.src = require('../../assets/image/noimage.png')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="card">
                <div class="card-body">
                  <h6 class="mb-1">Terbaru</h6>
                  <div
                    class="file-container2 p-2"
                    v-if="imagePreview.length > 0"
                    @dragover.prevent
                    @drop.prevent="handleDropFile"
                  >
                    <div class="row g-2">
                      <div
                        class="col-lg-4 col-md-4"
                        v-for="(file, index) in imagePreview"
                        :key="index"
                      >
                        <div style="height: 250px; position: relative">
                          <img
                            :src="file"
                            alt="Image Preview"
                            class="img-fluid"
                            style="
                              width: 100%;
                              height: 100%;
                              object-fit: cover;
                              pointer-events: none;
                              border-radius: 8px;
                            "
                          />
                          <div class="overlay-img">
                            <i
                              class="fas fa-times-circle"
                              @click="removeImage(index)"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4">
                        <div class="file-box2">
                          <div>
                            <p>Pindahkan atau pilih file disini</p>
                            <label
                              for="exampleFormControlInput3"
                              class="file-btn"
                            >
                              Pilih files
                              <input
                                type="file"
                                id="exampleFormControlInput3"
                                multiple
                                hidden
                                @change="handleFileSelect"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="imagePreview.length < 1"
                    class="file-container"
                    @dragover.prevent
                    @drop.prevent="handleDropFile"
                  >
                    <div class="file-box">
                      <p>Pindahkan atau pilih file disini</p>
                      <label for="exampleFormControlInput3" class="file-btn">
                        Pilih files
                        <input
                          type="file"
                          id="exampleFormControlInput3"
                          multiple
                          hidden
                          @change="handleFileSelect"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            data-bs-dismiss="modal"
            @click="closeModal"
          >
            Batal
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="upload"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imagePreview: [],
    };
  },
  computed: {
    detailAdd(){
      return this.$store.state.ImageProduct.detailAdd;
    }
  },
  methods: {
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.$store.commit("ImageProduct/SET_IMAGEFILES", files);
      this.generateImagePreview();
    },
    handleDropFile(event) {
      const droppedFiles = Array.from(event.dataTransfer.files);
      this.$store.commit("ImageProduct/SET_IMAGEFILES", droppedFiles);
      this.generateImagePreview();
    },
    generateImagePreview() {
      const imageFiles = this.$store.state.ImageProduct.imageFiles;
      this.imagePreview = [];
      if (imageFiles.length > 0) {
        const filePromises = imageFiles.map((file) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => {
              resolve(e.target.result);
            };
            reader.readAsDataURL(file);
          });
        });

        Promise.all(filePromises).then((filePreviews) => {
          this.imagePreview = filePreviews;
        });
      }
    },
    resetImages() {
      this.imagePreview = [];
      this.$store.commit("ImageProduct/RESET_IMAGEFILES");
    },
    removeImage(index) {
      this.imagePreview.splice(index, 1);
      this.$store.commit("ImageProduct/SPLICE_IMAGEFILES", index);
    },
    upload() {
      this.$store.dispatch("ImageProduct/uploadImagesTwo").then(() => {
        const status = this.$store.state.Alert.isAlerts[0].status;
        if (status) {
          setTimeout(() => {
            this.closeModal();
          }, 500);
        }
      });
    },
    closeModal(){
      this.$refs.closeModal.click();
      this.$store.commit("ImageProduct/SET_DETAIL_ADD", {});
      this.resetImages();
    }
  },
  created() {
    this.resetImages();
  },
};
</script>
<style scoped>
.file-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  background-color: #f9f9f9;
  padding: 10px;
}
.file-box {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  width: 60%;
  background-color: #fff;
  transition: border-color 0.3s ease;
}
.file-box:hover {
  border-color: #007bff;
}
.file-box p {
  margin: 10px 0;
  font-size: 14px;
  color: #555;
}
.file-btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff !important;
  font-size: 13px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
}
.file-btn:hover {
  background-color: #0056b3;
}

.file-container2 {
  background-color: #f9f9f9;
}
.file-box2 {
  border: 2px dashed #ccc;
  padding: 5px;
  border-radius: 8px;
  text-align: center;
  background-color: #fff;
  height: 100% !important;
  transition: border-color 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}
.file-box2 p {
  margin: 10px 0;
  font-size: 14px;
  color: #555;
}
.file-box2:hover {
  border-color: #007bff;
}
.file-btn2 {
  display: inline-block;
  padding: 10px 15px;
  background-color: #007bff;
  color: #fff !important;
  font-size: 13px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
}

.file-btn2:hover {
  background-color: #0056b3;
}

.file-container2 .overlay-img {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  margin-top: 2px;
  margin-right: 5px;
  color: rgba(215, 7, 7, 0.6);
}

.file-container2 .overlay-img:hover {
  background-color: rgba(0, 0, 0, 0.25);
  transition: background-color 0.3s ease;
}

.file-container2 .overlay-img i {
  font-size: 22px !important;
  cursor: pointer;
  color: #ff0000;
}
.file-container2 .overlay-img i:hover {
  color: #b30000;
}
</style>
